import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getServicesPath } from './servicesConfig';

const ServicesRedirect = () => {
  const { lang } = useParams();
  const targetLang = lang === 'fr' ? 'fr' : 'en';
  return <Navigate to={getServicesPath(targetLang)} replace />;
};

export default ServicesRedirect;
